import { Platform } from 'react-native';
import type { Language } from './types';

export const SUPPORTED_LANGUAGES = ['en', 'ru'] as const;

export function detectSystemLanguageTag(): string {
  if (Platform.OS === 'web' && typeof navigator !== 'undefined' && navigator.language) {
    return navigator.language;
  }

  try {
    return Intl.DateTimeFormat().resolvedOptions().locale || 'en';
  } catch {
    return 'en';
  }
}

export function resolveAppLanguage(tag: string): Language {
  const primary = tag.trim().toLowerCase().split(/[-_]/)[0];
  if (primary === 'ru') {
    return 'ru';
  }
  return 'en';
}

export function isSupportedAppLanguage(value: string): value is Language {
  return SUPPORTED_LANGUAGES.includes(value as Language);
}

export function normalizeLanguage(value?: string | null): Language {
  if (value && isSupportedAppLanguage(value)) {
    return value;
  }
  if (value) {
    return resolveAppLanguage(value);
  }
  return 'en';
}

export function normalizeSystemLanguageTag(tag?: string | null): string {
  const raw = (tag ?? detectSystemLanguageTag()).trim();
  if (!raw) {
    return 'en';
  }
  return raw.slice(0, 35);
}

export function getInitialAppLanguage(guestPreference?: Language | null): Language {
  if (guestPreference) {
    return guestPreference;
  }
  return resolveAppLanguage(detectSystemLanguageTag());
}
